export const checklistData = [
  {
    title: 'Voorbereidingen',
    items: [
      { name: 'Scheerapparaat laden', checked: false },
      { name: 'Tandenborstel laden', checked: false },
      { name: 'Powerbank laden', checked: false },
      { name: 'Telefoon opladen', checked: false },
      { name: 'Tablet opladen', checked: false },
      { name: 'Navigatiesysteem opladen', checked: false },
      { name: 'Vuilnis buitenzetten', checked: false },
      { name: 'Reisverzekering afsluiten / controleren', checked: false },
    ],
  },
    {
      title: 'Thuis',
      items: [
        { name: 'Prullenbakken legen', checked: false },
        { name: 'Deuren op slot', checked: false },
        { name: 'Ramen dicht / ventilatieroosters', checked: false },
        { name: 'Brood weg', checked: false },
        { name: 'Bederfbaar voedsel uit koelkast', checked: false },
        { name: 'Koffieautomaat schoonmaken', checked: false },
        { name: 'Planten water', checked: false },
        { name: 'Fietsen achter', checked: false },
        { name: 'Huis schoonmaken', checked: false },
        { name: 'Wekkers controleren / uit', checked: false },
        { name: 'Elektronica uit stopcontact', checked: false },
        { name: 'Verwarming laag of uit', checked: false },
        { name: 'Brievenbus legen', checked: false },
      ],
    },
    {
      title: 'Tas + spullen',
      items: [
        { name: 'Paspoort', checked: false },
        { name: 'Lange broeken', checked: false },
        { name: 'Korte broeken', checked: false },
        { name: 'Zembroek', checked: false },
        { name: 'Strandhandoek', checked: false },
        { name: 'T-shirts', checked: false },
        { name: 'Truien', checked: false },
        { name: 'Overhemd', checked: false },
        { name: 'Onderbroeken', checked: false },
        { name: 'Sokken', checked: false },
        { name: 'Tandenborstel', checked: false },
        { name: 'Tandpasta', checked: false },
        { name: 'Tanden rager / flossdraad', checked: false },
        { name: 'Gel', checked: false },
        { name: 'Gelkam', checked: false },
        { name: 'Deo', checked: false },
        { name: 'Luchtje', checked: false },
        { name: 'Scheerapparaat', checked: false },
        { name: 'Scheermesjes', checked: false },
        { name: 'Scheerschuim', checked: false },
        { name: 'Wattenstaafjes', checked: false },
        { name: 'Oplader', checked: false },
        { name: 'Sport shirt', checked: false },
        { name: 'Sport broek', checked: false },
        { name: 'Laptop', checked: false },
        { name: 'Boek', checked: false },
        { name: 'Verlengsnoer', checked: false },
        { name: 'Laptoplader', checked: false },
        { name: 'Vitamine / supplementen', checked: false },
        { name: 'Hoofdtelefoon / Oortjes', checked: false },
        { name: 'Medicijnen', checked: false },
        { name: 'EHBO-set', checked: false },
        { name: 'Zonnebril', checked: false },
        { name: 'Portemonnee', checked: false },
        { name: 'Reisdocumenten', checked: false },
        { name: 'Reserveringsbevestigingen', checked: false },
      ],
    },
    {
      title: 'Zonvakantie',
      items: [
        { name: 'Zonnebril', checked: false },
        { name: 'Zonnebrand', checked: false },
        { name: 'Petje', checked: false },
        { name: 'Slippers', checked: false },
        { name: 'Strandtas', checked: false },
        { name: 'Snorkelset', checked: false },
        { name: 'After-sun', checked: false },
        { name: 'Strandspelletjes (frisbee, bal)', checked: false },
      ],
    },
    {
      title: 'Wintersport',
      items: [
        { name: 'Skijas', checked: false },
        { name: 'Skibroek', checked: false },
        { name: 'Skisokken', checked: false },
        { name: 'Handschoenen', checked: false },
        { name: 'Sjaal / Buff', checked: false },
        { name: 'Skibril', checked: false },
        { name: 'Helm', checked: false },
        { name: 'Thermokleding', checked: false },
        { name: 'Skipas', checked: false },
        { name: 'Sneeuwkettingen', checked: false },
      ],
    },
    {
      title: 'Doe vakantie',
      items: [
        { name: 'Wandelschoenen', checked: false },
        { name: 'Wandelstok', checked: false },
        { name: 'Regenjas', checked: false },
        { name: 'Rugzak', checked: false },
        { name: 'Waterfles', checked: false },
        { name: 'Zakmes', checked: false },
        { name: 'Verrekijker', checked: false },
        { name: 'Kaart / GPS', checked: false },
        { name: 'Insectenspray', checked: false },
      ],
    },
    {
      title: 'Optioneel',
      items: [
        { name: 'Beddengoed', checked: false },
        { name: 'Handdoeken', checked: false },
        { name: 'Speelkaarten', checked: false },
        { name: 'Gezelschapsspel', checked: false },
        { name: 'Fotocamera', checked: false },
        { name: 'Statief', checked: false },
        { name: 'Paraplu', checked: false },
        { name: 'Extra schoenen', checked: false },
        { name: 'Nekkussen voor in de auto/vliegtuig', checked: false },
      ],
    },
  ]